import React, { Component } from 'react';

interface NewLineToBrProps {
    value: string
}

const NewLineToBr: React.SFC<NewLineToBrProps> = (props: any) => (props.value || '').split('\n')
    .reduce((arr, line, index) => arr.concat(
        <React.Fragment key={index}>
            {line}
            <br />
        </React.Fragment>,
    ), [])

export default NewLineToBr;
